import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DataQualityWarningAssetFragmentGql } from './DataQualityWarningAssetFragmentGql';
import { DataQualityWarningFragmentGql } from './DataQualityWarningFragmentGql';

export const MetricUpstreamDataQualityWarningsQueryGql: DocumentNode = gql`
    query MetricUpstreamDataQualityWarningsQuery($metricLuid: String!, $first: Int!, $offset: Int!, $publishedConnectionsLineageEnabled: Boolean!) {
        metrics (filter: {luid: $metricLuid}){
            upstreamDataQualityWarningsConnection (filter: {isActive: true},
                first: $first, offset: $offset,
                orderBy: {field: IS_SEVERE, direction: DESC}) {
                totalCount
                nodes {
                    id
                    ...DataQualityWarningFragment
                    ...DataQualityWarningAssetFragment
                }
            }
        }
    }

    ${DataQualityWarningFragmentGql}
    ${DataQualityWarningAssetFragmentGql}
`;
